import React, {useState} from 'react';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";
import {formatDateTime} from "../../api/utils/DateFormatter";


export function SingleExecutionTitle({execution, deleteSingleExecution}) {
    const [isDeleting, setIsDeleting] = useState(false)
    return <div style={{}}>

        <div title={execution.name} style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }}>

            <div style={{
                maxWidth: "100%", whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
                alignItems:"center",
                gap:"5px"
            }}>
                {getTag(execution)}
                <h4 style={{
                    marginLeft: "10px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    margin: 0
                }}

                > {execution.name} </h4>

            </div>
            <div>

                <Button
                    disabled={isDeleting}
                    onClick={async () => {
                        setIsDeleting(true)
                        await deleteSingleExecution(execution.id)
                    }}
                    size="small"
                    icon={`pi ${isDeleting ? "pi-spinner pi-spin" : "pi-trash"}`}
                    severity={"danger"} text/>
            </div>

        </div>
    </div>;
}

export function ExecutionDetailsTitle(execution) {
    return <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <div style={{flex: 20}}>
            <p className={"m-1 ml-0"}>Execution details {execution && `: ${execution.name}`}</p>
            {execution && <span style={{fontSize: "15px"}}
                                className={"m-1 ml-0"}>{formatDateTime(new Date(execution?.executionDate))}</span>}
        </div>
        <div style={{flex: 2, display: "flex", justifyContent: "flex-end"}}>
            {getBadge(execution, "large")}
        </div>
    </div>
}

export function getBadge(execution, size) {
    switch (execution?.status) {
        case "IN_PROGRESS":
            return <Badge style={{backgroundColor: "rgb(233, 233, 35)"}}
                          size={size}
                          value="In progress"></Badge>;
        case "COMPLETED":
            return <Badge style={{backgroundColor: "rgb(63, 156, 53)"}}
                          size={size} severity={"success"} value="Completed"></Badge>;
        case "FAILED":
            return <Badge style={{backgroundColor: "red"}}
                          size={size} severity={"danger"} value="Failed"></Badge>;
    }
}

export function getTag(execution) {

    switch (execution?.status) {
        case "IN_PROGRESS":
            return <Badge style={{backgroundColor: "rgb(233, 233, 35)", fontSize: "10px"}} value=""></Badge>;
        case "COMPLETED":
            return <Badge style={{backgroundColor: "rgb(63, 156, 53)", fontSize: "10px"}} value=""></Badge>;
        case "FAILED":
            return <Badge style={{backgroundColor: "red", fontSize: "10px"}} value=""></Badge>;

    }
}